import { action, computed, makeObservable } from 'mobx'

import {
  UserBasicInfoSettingsStore,
  UserDeleteAccountStore,
  UserLoginInfoSettingsStore,
  UserRequestDataStore,
} from 'shared/stores'

import { ApiStatusStore } from 'supplier/stores'

class AccountSettingsStore {
  /** @type {import('../root').RootStore} */
  root

  userBasicInfoSettings = new UserBasicInfoSettingsStore(this)
  userLoginInfoSettings = new UserLoginInfoSettingsStore(this)
  userRequestDataStore = new UserRequestDataStore(this)
  userDeleteAccountStore = new UserDeleteAccountStore(this)

  apiStatus = new ApiStatusStore()

  /**
   * @param {import('../root').RootStore} root
   */
  constructor (root) {
    makeObservable(this)
    this.root = root
  }

  @action.bound
  async fetch () {
    this.apiStatus.startLoad()
    try {
      await Promise.all([
        this.userBasicInfoSettings.fetch(),
        this.userLoginInfoSettings.fetch(),
        this.userRequestDataStore.fetch(),
        this.userDeleteAccountStore.fetch(),
      ])
      this.apiStatus.finishLoad()
    } catch (error) {
      this.apiStatus.failLoad('We could not fetch the account settings. Please try again in a minute.')
      throw error
    }
  }

  @action.bound
  async refreshUserProfile () {
    return this.root.userProfileStore.fetch()
  }

  @computed get isLoaded () {
    return (
      this.userBasicInfoSettings.loading.isLoaded &&
      this.userLoginInfoSettings.loading.isLoaded &&
      this.userRequestDataStore.loading.isLoaded &&
      this.userDeleteAccountStore.loading.isLoaded
    )
  }
}

export default AccountSettingsStore
